import React, { useState } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className={styles.header}>
      <div className={styles.logo}>Megaloto</div>
      <nav className={`${styles.nav} ${isMenuOpen ? styles.open : ''}`}>
        <ul>
          <li><a href="#home">Inicio</a></li>
          <li><a href="#games">Juegos</a></li>
          <li><a href="#promotions">Promociones</a></li>
          <li><a href="#how-it-works">Cómo funciona</a></li>
          <li><a href="https://w.app/MegalotoAyuda">Ayuda</a></li>
        </ul>
      </nav>
      <div className={styles.actions}>
        <a href="/login" className={styles.login}>Iniciar sesión</a>
        <a href="/login" className={styles.register}>Regístrate</a>
      </div>
      <button className={styles.menuButton} onClick={toggleMenu}>
        ☰
      </button>
    </header>
  );
};

export default Header;
